import { SVGIconComponent } from './types';

export const StatusDelivered: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="timeline/status-delivered" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M20.8823529,7.77392162 L20.8823529,16.6053249 C20.8823529,16.7504109 20.8006139,16.8832092 20.6704498,16.9453872 L20.6704498,16.9453872 L12.3134698,21 L12.3134698,11.9306217 L20.8823529,7.77392162 Z M3,7.74002346 L6.74211102,9.57003265 L6.74211102,11.6748625 L8.60526211,12.8086331 L8.60537834,10.4812151 L11.5688835,11.9297177 L11.5688835,20.9998817 L3.21190312,16.9452693 C3.08248684,16.8823268 3,16.7502891 3,16.6044406 L3,16.6044406 L3,7.74002346 Z M17.5850877,5.69748758 L20.5100404,7.11604192 L11.9418935,11.2726437 L9.02236524,9.8456394 L17.5850877,5.69748758 Z M11.7806704,3.03684582 C11.8828442,2.98771806 12.0001407,2.98771806 12.1023029,3.03684582 L12.1023029,3.03684582 L15.7233315,4.79392975 L7.16812579,8.93913391 L3.40625477,7.09990836 Z"
        id="Combined-Shape"
        fill="currentColor"
      ></path>
    </g>
  </svg>
);
